import { AUTOMATION_PROJECT_TYPE_PIPE } from "../lib/types";

export class BackgroundPipe {
  /**
   * @param {number} x
   * @param {number} y
   * @param {number} rotation
   * @param {number} scaleX
   * @param {number} scaleY
   * @param {number} width
   * @param {number} height
   * @param {string} data
   */
  constructor(
    x = 0,
    y = 0,
    scaleX = 0,
    scaleY = 0,
    rotation = 0,
    width = 0,
    height = 0,
    data = null
  ) {
    this.x = x;
    this.y = y;
    this.scaleX = scaleX;
    this.scaleY = scaleY;
    this.rotation = rotation;
    this.width = width;
    this.height = height;
    this.data = data;
  }
}

export class EmailPipe {
  /**
   * @param to {string}
   * @param drawingsURL {string}
   * @param boomURL {string}
   * @param isInternal {boolean}
   * @param chamber {string}
   * @param outlet {string}
   * @param name {string}
   * @param engineer {string}
   * @param location {string}
   * @param requiredvolume {number}
   * @param porosity {number}
   * @param stoneBelow {number}
   * @param stoneAbove{number}
   * @param avgCover {number}
   * @param availableLength {number}
   * @param availableWidth {number}
   * @param installedVolume {number}
   * @param chamberStorage {number}
   * @param numOfChambers {number}
   * @param numOfEndcaps {number}
   * @param numOfRows {number}
   * @param avgRowLength {number}
   * @param maxLength {number}
   * @param maxWidth {number}
   * @param approxBedSize{number}
   * @param amountStone {number}
   * @param excavationVolume {number}
   * @param nonWovenRequired {number}
   * @param isolatorRowLength {number}
   * @param nonWovenIsolator {number}
   * @param wovenIsolator {number}
   */
  constructor(
    to = null,
    drawingsURL = '',
    boomURL = '',
    isInternal = true,
    name = '',
    engineer = '',
    location = '',
    pipeType = '',
    pipeFitting = '',
    pipeDiameter = 0,
    systemType = '',
    thermoplasticLiner = false,
    requiredvolume = 0,
    porosity = 0,
    stoneBelow = 0,
    stoneAbove = 0,
    avgCover = 0,
    availableLength = 0,
    availableWidth = 0,
    installedVolume = 0,
    pipeStorage = 0,
    numOfSticks = 0,
    numOfSingleTees = 0,
    numOfDoubleTees = 0,
    numOfTripleTees = 0,
    numOfBends = 0,
    numOfRows = 0,
    maxLength = 0,
    maxWidth = 0,
    approxBedSize = 0,
    amountStone = 0,
    excavationVolume = 0
  ) {
    this.to = to;
    /* drawing and BOM urls */
    this.drawingsURL = drawingsURL;
    this.boomURL = boomURL;
    this.isInternal = isInternal;
    /* the numeric table values */
    this.name = name;
    this.engineer = engineer;
    this.location = location;
    this.pipeType = pipeType;
    this.pipeFitting = pipeFitting;
    this.pipeDiameter = pipeDiameter;
    this.systemType = systemType;
    this.thermoplasticLiner = thermoplasticLiner;
    this.requiredvolume = requiredvolume;
    this.porosity = porosity;
    this.stoneBelow = stoneBelow;
    this.stoneAbove = stoneAbove;
    this.avgCover = avgCover;
    this.availableLength = availableLength;
    this.availableWidth = availableWidth;
    this.installedVolume = installedVolume;
    this.pipeStorage = pipeStorage;
    this.numOfSticks = numOfSticks;
    this.numOfSingleTees = numOfSingleTees;
    this.numOfDoubleTees = numOfDoubleTees;
    this.numOfTripleTees = numOfTripleTees;
    this.numOfBends = numOfBends;
    this.numOfRows = numOfRows;
    this.maxLength = maxLength;
    this.maxWidth = maxWidth;
    this.approxBedSize = approxBedSize;
    this.amountStone = amountStone;
    this.excavationVolume = excavationVolume;
    this.date = new Date().toLocaleString('en-US').replace(",", "").replace(/(\s|\/)/g, "-");
  }
}

export class StoneBedPipe {
  constructor() {
    this.points = [];
  }

  /**
   *
   * @param {number} index
   * @param {number} x
   * @param {number} y
   */
  addPoint(index, x, y) {
    this.points[index] = {
      x,
      y
    };
  }
}

export class PipeBed {
  /**
   * @param {number} x
   * @param {number} y
   * @param {number} rotation
   * @param {number} width
   * @param {number} height
   */
  constructor(x = 0, y = 0, rotation = 0, width = 0, height = 0) {
    this.x = x;
    this.y = y;
    this.rotation = rotation;
    this.width = width;
    this.height = height;
    this.elements = [];
  }

  addElement(element) {
    this.elements.push(element);
  }
}

export class pipeElement {
  /**
   * @param {number} row
   * @param {number} offSet
   * @param {number} x
   * @param {number} y
   * @param {number} absltX
   * @param {number} absltY
   * @param {number} pixelOffset
   * @param {boolean} isIsolator
   * @param {number} height
   * @param {number} width
   * @param {number} rotation
   * @param {number} absltRotation
   */
  constructor(
    x,
    y,
    id,
    accessories
  ) {
    ;
    this.id = id;
    this.x = x;
    this.y = y;
    this.accessories = accessories;
  }
}

/**
 * The main project class. This will iterate.
 */
export class ProjectPipe {
  projectType = AUTOMATION_PROJECT_TYPE_PIPE
  constructor() {
    this.pipeBed = null;
    this.email = null;
    this.background = null;
    this.stoneBed = null;
    this.pipeType = null;
    this.pipeFitting = null;
    this.pipeDiameter = null;
    this.systemType = null;
    this.thermoplasticLiner = false;
    this.region = null;
    this.language = null;
    this.units = null;

    this.metaData = {
      scaleValue: 0.0,
      scalePixels: 0.0,
      porousStoneAbove: 0.0,
      porousStoneBelow: 0.0,
      porosityPercent: 0.0,
      totalStorageProvided: 0.0,
      stonePerimeterSeparation: 0.0,
      pipeFlowDirection: ""
    };
  }

  setRegion(value) {
    this.region = value;
  }
  setLanguage(value) {
    this.language = value;
  }
  setUnits(value) {
    this.units = value;
  }
  setPipeBed(value) {
    this.pipeBed = value;
  }
  setEmail(value) {
    this.email = value;
  }
  setScaleValue(value) {
    this.metaData.scaleValue = value;
  }
  setScalePixels(value) {
    this.metaData.scalePixels = value;
  }
  setPorousStoneAbove(value) {
      if (value)
          this.metaData.porousStoneAbove = value;
      else if (!this.metaData.porousStoneAbove)
          this.metaData.porousStoneAbove = 0;
  }
  setPorousStoneBelow(value) {
      if (value)
          this.metaData.porousStoneBelow = value;
      else if (!this.metaData.porousStoneBelow)
          this.metaData.porousStoneBelow = 0;
  }
  setPorosityPercent(value) {
    this.metaData.porosityPercent = value;
  }
  setBaseStoneElevation(value) {
    this.metaData.baseStoneElevation = value;
  }
  setTotalStorageProvided(value) {
    this.metaData.totalStorageProvided = value;
  }
  setPipeFlowDirection(value) {
    this.metaData.pipeFlowDirection = value;
  }
  setStonePerimeterSeparation(value) {
    this.metaData.stonePerimeterSeparation = value;
  }
  setPipeType(value) {
    this.pipeType = value;
  }
  setPipePipeFitting(value) {
    this.pipeFitting = value;
  }
  setPipeDiameter(value) {
    this.pipeDiameter = value;
  }
  setSystemType(value) {
    this.systemType = value;
  }
  setThermoplasticLiner(value) {
    this.thermoplasticLiner = value;
  }
  setBackground(bg) {
    this.background = bg;
  }
  setStoneBed(stnBd) {
    this.stoneBed = stnBd;
  }
  serialize() {
    return JSON.stringify(this);
  }
}



// WEBPACK FOOTER //
// ./src/lib/project-build-pipe.js